import React from "react";
import "./css/SupportSection.css";
import { FaPhoneAlt, FaEnvelope, FaHeadset } from "react-icons/fa";

const SupportSection = () => {
  return (
    <div className="supportSection">
      <h2 className="supportHeading">Need Help? We’re Here for You</h2>
      <p className="supportSubHeading">
        Our team is available round the clock to assist you.
      </p>

      <div className="supportGrid">
        <div className="supportBox">
          <FaPhoneAlt className="supportBoxIcon" />
          <h4>Call Us</h4>
          <p>Talk directly to our support team</p>
          <a href="tel:+919980944799">+91 876 256 7644</a>
        </div>

        <div className="supportBox">
          <FaEnvelope className="supportBoxIcon" />
          <h4>Email Us</h4>
          <p>Send us your queries anytime</p>
          <a href="mailto:sales@miniandjone.com">sales@miniandjone.com</a>
        </div>

        <div className="supportBox">
          <FaHeadset className="supportBoxIcon" />
          <h4>24x7 Support</h4>
          <p>On-trip hassle free assistance</p>
          <span className="supportTag">Always Available</span>
        </div>
      </div>
    </div>
  );
};

export default SupportSection;
